module.exports = __webpack_public_path__ + "static/media/onboarding-bg.b33b9af9.svg";